import { Component, OnInit } from '@angular/core';
import {OrderStateService, StatePosition} from '@app/webshop/field-agent/shared/services/order-state.service';
import _ from 'lodash';

@Component({
    selector: 'app-order-state',
    templateUrl: './order-state.component.html',
    styleUrls: ['./order-state.component.less']
})
export class OrderStateComponent implements OnInit {
    states = [
        { name: 'Select Templates', abbreviation: 'st', isCurrent: false },
        { name: 'Select Products', abbreviation: 'sprd', isCurrent: false },
        { name: 'Check Cart', abbreviation: 'cc', isCurrent: false },
        { name: 'Select Supplier', abbreviation: 'ss', isCurrent: false },
        { name: 'Select Promotion', abbreviation: 'sprm', isCurrent: false },
        { name: 'Verify Promotion', abbreviation: 'vprm', isCurrent: false },
        { name: 'Confirm Order', abbreviation: 'co', isCurrent: false }
    ];

    constructor(private orderStateService: OrderStateService) {}

    ngOnInit(): void {
        this.orderStateService.currentState$.subscribe((currentState) => {
            this.states = this.states.map((state) => ({
                ...state,
                isCurrent: state.abbreviation === currentState
            }));
        });
    }

    getClass(id: string, isCurrent: boolean) {

        let position = this._checkStatePosition(id);

        if (StatePosition.Current === position) {
            return 'in-progress';
        } else if (StatePosition.After === position) {
            return '';
        } else {
            return 'complete';
        }
    }

    get inProgressStatePosition(): number {
        return _.findIndex(this.states, (state) => state.isCurrent);
    }

    private _checkStatePosition(state: string): StatePosition {
        const currentPos = this._getStatePosition(state);
        if (currentPos === this.inProgressStatePosition) {
            return StatePosition.Current;
        } else if (currentPos < this.inProgressStatePosition) {
            return StatePosition.Before;
        } else {
            return StatePosition.After;
        }
    }

    private _getStatePosition(stateAbbreviation: string): number {
        let position = 0;

        position = _.findIndex(this.states, (state) => _.camelCase(state.abbreviation) === stateAbbreviation);

        return position;
    }
}
